enum LoadingScopesEnum {
  PAGE = 'PAGE',
  INFO_CARD = 'INFO_CARD',
}

export default LoadingScopesEnum;
